import { createContext, RefObject, useContext } from "react";

interface MainLayoutContextValue {
  mainRef: RefObject<HTMLDivElement>;
  sidebarOpen: boolean;
}

export const MainLayoutRefContext = createContext<MainLayoutContextValue | null>(null);
export const useMainLayoutRef = () => useContext(MainLayoutRefContext);
